import React from 'react'
import { createContext, useReducer } from 'react'

const initialState = {
  entity: {},
  template_id: null,
  signers: {},
}

const ScheduleESigningContext = createContext({
  state: initialState,
})

const addEntity = (dispatch, entity) => {
  dispatch({
    type: 'ADD_ENTITY',
    payload: {
      entity: entity,
    },
  })
}

const addTemplate = (dispatch, template_id) => {
  dispatch({
    type: 'ADD_TEMPLATE',
    payload: {
      template_id: template_id,
    },
  })
}

const addSigner = (dispatch, key, signer, role) => {
  dispatch({
    type: 'ADD_SIGNER',
    payload: {
      signer: { ...signer, role: role },
      key: key,
    },
  })
}

const resetSigners = (dispatch) => {
  dispatch({
    type: 'RESET_SIGNERS',
  })
}

const removeSignerWithSameRole = (signers, role) => {
  if (!signers) return
  const keyToRemove = Object.keys(signers).find((key) => signers[key].role === role)
  if (!keyToRemove) return { ...signers }
  const { [keyToRemove]: _ignore, ...rest } = signers

  return rest
}

const addSignerAction = (state, action) => {
  const signersRemovingRole = removeSignerWithSameRole(state.signers, action.payload.signer.role)
  return {
    ...state,
    signers: {
      ...signersRemovingRole,
      [action.payload.key]: action.payload.signer,
    },
  }
}

const reducer = (state, action) => {
  switch (action.type) {
    case 'ADD_SIGNER':
      return addSignerAction(state, action)
    case 'ADD_ENTITY':
      return {
        ...state,
        entity: action.payload.entity,
      }
    case 'ADD_TEMPLATE':
      return {
        ...state,
        template_id: action.payload.template_id,
      }
    case 'RESET_SIGNERS':
      return {
        ...state,
        signers: [],
      }
    default:
      return { ...state }
  }
}

export const ScheduleESigningProvider = (props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  return (
    <ScheduleESigningContext.Provider
      value={{
        ...state,
        addSigner: (key, signer, role) => addSigner(dispatch, key, signer, role),
        resetSigners: () => resetSigners(dispatch),
        addEntity: (entity) => addEntity(dispatch, entity),
        addTemplate: (template_id) => addTemplate(dispatch, template_id),
      }}
    >
      {props.children}
    </ScheduleESigningContext.Provider>
  )
}

export default ScheduleESigningContext
